/* Tiện ích xuất Excel dùng chung cho tab Export và tab Out */
import * as XLSX from 'xlsx';
import { log } from './ui.js';

export function widths(rows) {
  const w = [];
  (rows[0] || []).forEach((_, i) => {
    let m = 10;
    rows.forEach((r) => { m = Math.max(m, Math.min(52, String(r[i] == null ? '' : r[i]).length + 2)); });
    w.push({ wch: m });
  });
  return w;
}
export function fname(pre) {
  const d = new Date(), p = (x) => String(x).padStart(2, '0');
  return pre + '_' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '_' + p(d.getHours()) + p(d.getMinutes()) + '.xlsx';
}
export function saveBook(wb, name) {
  try { XLSX.writeFile(wb, name); log('Đã xuất ' + name, 'ok'); }
  catch (e) { log('Không xuất được file: ' + e.message, 'er'); }
}
/* sheets: [{name, rows}] → tải file */
export function saveSheets(sheets, name) {
  const wb = XLSX.utils.book_new();
  sheets.forEach((x) => {
    const rows = x.rows.length > 1 ? x.rows : x.rows.concat([['(không có)']]);
    const ws = XLSX.utils.aoa_to_sheet(rows); ws['!cols'] = widths(rows);
    XLSX.utils.book_append_sheet(wb, ws, x.name.slice(0, 31));
  });
  saveBook(wb, name);
}
